import { render, staticRenderFns } from "./OrderPaymentTypeChart.vue?vue&type=template&id=005b67c2&"
import script from "./OrderPaymentTypeChart.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports